module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00050-fs8.60287f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00050-fs8.png
// module id = 203
// module chunks = 0